<template>
    <div>
        <PlusButton @click="openPanel()"></PlusButton>
        <SlideOver :show="open" @close="open = false">
            <FormLabel :value="$t('messages.search')" for="search" />
            <FormInput
                required
                id="search"
                v-model.trim="search"
                name="search"
                type="text"
                max="60"
                class="mt-1 w-full"
                autocomplete="off"
            />

            <div>
                <template v-for="(student, index) in students" :key="index">
                    <ul class="mt-5">
                        <li>
                            <img
                                :src="student.avatar_or_default"
                                alt="profile photo"
                                class="relative z-30 inline-block h-10 w-10 rounded-full ring-2 ring-white"
                            />
                            {{ student.full_name }}
                            <PlusButton @click="selectStudent(student)"></PlusButton>
                        </li>
                    </ul>
                </template>
            </div>
        </SlideOver>
    </div>
</template>

<script>
import PlusButton from '@/components/Forms/PlusButton.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import axios from 'axios';
import SlideOver from '@/components/SlideOver.vue';

export default {
    emits: ['select-student'],
    name: 'SearchStudentPanel',

    components: {
        SlideOver,
        FormInput,
        FormLabel,
        PlusButton,
    },

    data() {
        return {
            open: false,
            search: '',
            students: [],
        };
    },

    watch: {
        search(newVal) {
            if (newVal.length <= 2) {
                this.students = [];
            } else {
                this.searchUsers(newVal);
            }
        },
    },

    methods: {
        openPanel() {
            this.open = true;
        },
        selectStudent(student) {
            this.$emit('select-student', student);
            this.open = false;
            this.search = '';
            this.students = [];
        },
        searchUsers() {
            axios
                .get(this.route('students.search', { search: this.search }))
                .then((response) => (this.students = response.data.users));
        },
    },
};
</script>
